<template>
<div class="free-dashboard-layout">
  <EnterParentPassword
      v-if="screen === 'passcode'"
      @onBackClick="screen = 'main'"
      :passToCheck="accountPassword"
      :hideBackButton="true"
      @submitSuccess="unlockDashboard"/>
  <div v-if="screen === 'dashboard'">
    <div class="action-arrow mobile-hidden" v-if="showPopupNotification && !isAndroid">
      {{$lang.messages.free_dashboard.how_open_kids_mode}}
      <div class="span-rounded">?</div>
      <img src="../assets/img/action-pointer.png" alt="arrow">
    </div>
    <HeaderPopup>
      <div class="mr-1 ml-1" v-if="$route.path === '/freeDashboard'">
        <h2 class="text-center mb-05 mt-0 mobile-hidden">
          {{$lang.messages.free_dashboard.welcome_parent_mode}}
        </h2>
        <p class="mobile-hidden text-center">
          {{$lang.messages.free_dashboard.description}}
          <a class="free-dashboard-header-link" href="#" @click.prevent="showWelcomeScreen = true">{{$lang.messages.learn_more}}</a>
        </p>
      </div>
    </HeaderPopup>
    <div class="popup-dashboard-header tablet-hidden" v-if="$route.path === 'freeDashboard'">
      {{$lang.messages.parent_mode}}
    </div>
    <router-view :showHeader="false" :showTabs="false" :isTab="true" :showLockButton="true"/>
  </div>
  <Help/>
  <WelcomeScreens alias="dashboardFreeWelcome"  v-if="showWelcomeScreen" @hidewelcome="showWelcomeScreen = false"/>
</div>
</template>

<script>
import HeaderPopup from "@/components/HeaderPopup";
import saveSetting from "../components/mixins/saveSetting";
import EnterParentPassword from "@/components/EnterParentPassword"
import Help from "@/components/Help"
import WelcomeScreens from "@/components/WelcomeScreens";
import {mapGetters, mapState} from "vuex";

export default {
  name: "FreeDashboard",
  mixins: [saveSetting],
  data: function () {
    return {
      locked: false,
      showError: false,
      passCode: '',
      screen: window.sessionStorage.getItem('unlocked') || this.$route.query.skipPass ? 'dashboard' : 'passcode',
      isAndroid: window.Android,
      isMobileView: window.innerWidth <= 768,
      showWelcomeScreen: !localStorage.getItem('dashboardFreeWelcome'),
      currentWelcomeSlideIndex: 0,
      welcomeSlidesData: [
        {
          img: require('../assets/img/welcome/welcome-parent-mode-1.png'),
          label: this.$lang.messages.free_dashboard.welcome.feature_1
        },
        {
          img: require('../assets/img/welcome/welcome-parent-mode-2.png'),
          label: this.$lang.messages.free_dashboard.welcome.feature_2
        }
      ],
    }
  },
  components: {
    HeaderPopup,
    EnterParentPassword,
    Help,
    WelcomeScreens
  },
  computed: {
    ...mapGetters({
      currentDevice: 'currentDevice',
    }),
    ...mapState({
      currentDeviceID: state => state.currentDeviceID,
      accountPassword: state => state.accountData.password,
      popupOpen: state => state.accountData.popupOpen,
    }),

    showPopupNotification() {
      return !this.popupOpen && this.$store.state.hideWelcome;
    }
  },
  methods: {
    beforeWelcomeSlideChange(slideIndex) {
      this.currentWelcomeSlideIndex = slideIndex + 1;
    },
    hideWelcomeModal() {
      this.showWelcome = false;
    },
    unlockDashboard() {
      this.screen = 'dashboard';
      sessionStorage.setItem('unlocked', '1');
    },
  },
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.free-dashboard-layout {
  width: 100%;
  min-height: 100%;
  padding-bottom: 30px;
  background: linear-gradient(0deg, #F5F7FB, #F5F7FB), linear-gradient(331.33deg, #CFD1F4 11.55%, #EFF1FF 51.74%), #F5F7FB;

  .header.-white {
    background-color: #fff;

    @media all and (min-height: 900px){
      min-height: 137px;
    }
  }

  .add-child-slider {
    padding: 0;
  }
  
  .profile-wrapper > .content-block {
    background-color: #fff;
  }
}

.free-dashboard-header-title {
  color: #5A4A99;
  line-height: 25px;
  font-size: 18px;
  font-weight: bold;
  text-shadow: 0px 1px 0px rgba(255, 255, 255, 0.3);
}

.free-dashboard-header-text {
  font-size: 14px;
  line-height: 19px;
  color: #413B3D;
}

.free-dashboard-header-link {
  color: #008dff;
  text-decoration: underline;
}

.action-arrow {
  padding: 5px 125px 5px 15px;
  background: #FDD04C;
  height: 120px;
  display: flex;
  font-weight: 800;
  font-size: 26px;
  line-height: 1.4;
  color: #27272C;
  align-items: center;
  justify-content: flex-end;

  @include responsive-below($md){
    font-size: 20px;
  }

  img {
    width: 601px;
    max-width: 50%;
    margin-left: 62px;
  }
}

.span-rounded {
  width: 52px;
  min-width: 52px;
  height: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50% ;
  background-color: #D8A30A;
  margin-left: 20px;
}
</style>